import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { BRAND, DEFAULT_DESC, resolve } from "./seoData";

export const RouteSeo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const [title, desc] = resolve(pathname);
    document.title = pathname === "/" ? title : `${title} | ${BRAND}`;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc);
    let og = document.querySelector('meta[property="og:title"]');
    if (!og) {
      og = document.createElement("meta");
      og.setAttribute("property", "og:title");
      document.head.appendChild(og);
    }
    og.setAttribute("content", document.title);
    let ogd = document.querySelector('meta[property="og:description"]');
    if (!ogd) {
      ogd = document.createElement("meta");
      ogd.setAttribute("property", "og:description");
      document.head.appendChild(ogd);
    }
    ogd.setAttribute("content", desc);
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    const noindexPaths = ["/admin", "/thank-you", "/webmail", "/attendance-correction", "/leave-request", "/field-duty", "/my-requests", "/receipts", "/preview/home", "/hold-upload", "/resubmit"];
    const isPrivate = noindexPaths.includes(pathname) || pathname.startsWith("/admin") || pathname.startsWith("/connect");
    robots.setAttribute("content", isPrivate ? "noindex" : "index,follow");
    // canonical: single preferred URL per page (no trailing slash, no query/hash) — fixes
    // Search Console "Duplicate without user-selected canonical"
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    const cleanPath = pathname !== "/" && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    const canonUrl = `https://nexsecure.in${cleanPath}`;
    canon.setAttribute("href", canonUrl);
    // og:url mirrors the canonical so social/crawler signals agree on one URL per page
    let ogu = document.querySelector('meta[property="og:url"]');
    if (!ogu) {
      ogu = document.createElement("meta");
      ogu.setAttribute("property", "og:url");
      document.head.appendChild(ogu);
    }
    ogu.setAttribute("content", canonUrl);
  }, [pathname]);
  return null;
};
